import React from "react";
import "@/assets/css/animations.css";
import "@/assets/css/bootstrap.min.css";
import "@/assets/css/fonts.css";
import "@/assets/css/main.css";
import { Link } from "react-router-dom";

const Header: React.FC = () => {
    return (

        <header className="page_header cs main_color2 bordered_items columns_padding_0 toggle_menu_left not_hide_menuitems with_top_border">
            <div>
                <title>Güneş Gaz</title>
                <meta charSet="utf-8" />
                {/* [if IE]> */}
                <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
                {/* <![endif] */}
                <meta name="description" content="Güneş Gaz" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            </div>

            <div
                className="modal"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="search_modal"
                id="search_modal"
            >
                <div className="widget widget_search">
                    <form method="get" className="searchform form-inline" action="/">
                        <div className="form-group">
                            <input
                                type="text"
                                name="search"
                                className="form-control"
                                placeholder="Search keyword"
                                id="modal-search-input"
                            />
                        </div>
                        <button type="submit" className="theme_button">
                            Ara
                        </button>
                    </form>
                </div>
            </div>

            <div
                className="container"
                style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
            >
                <div className="row">
                    <div className="col-sm-12 text-right">
                        <div className="menu-container">
                            {/* main nav start */}
                            <nav className="mainmenu_wrapper">
                                <ul className="mainmenu nav sf-menu">
                                    {/* Örnek Anasayfa ve Hakkımızda */}
                                    <li className="active">
                                        <Link to="/">Anasayfa</Link>
                                    </li>
                                    <li>
                                        <Link to="/hakkimizda">Hakkımızda</Link>
                                    </li>

                                    {/* ÜRÜNLER */}
                                    <li>
                                        <Link to="/urunler">Ürünler</Link>
                                        <ul>
                                            {/* GAZLAR */}
                                            <li>
                                                <Link to="/urunler-liste/0">Gazlar</Link>
                                                <ul>
                                                    {/* SINAİ GAZLAR */}
                                                    <li
                                                        style={{
                                                            listStyle: "none",
                                                            fontWeight: "bold"
                                                        }}
                                                    >
                                                        <Link to={"/urunler/" + "677e205ac44fb038b4a85c26"}
                                                            style={{
                                                                padding: 0,
                                                                paddingLeft: 15,
                                                                paddingRight: 15,
                                                                fontSize: "14px"
                                                            }}
                                                        >
                                                            Sinai Gazlar
                                                            <div>
                                                                <Link
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        padding: 0,
                                                                        paddingLeft: 10,
                                                                        fontSize: "13px",
                                                                        color: "#30355d"
                                                                    }}
                                                                    to={"#"}
                                                                    onMouseOver={(e) => e.preventDefault()}
                                                                >
                                                                    Tüpte
                                                                    <div
                                                                        style={{
                                                                            display: "inline-block",
                                                                            color: "red !important"
                                                                        }}
                                                                    >
                                                                        {[
                                                                            {
                                                                                title: "Amonyak",
                                                                                url: "/urun-detay/677e2477c44fb038b4a86181"
                                                                            },

                                                                            {
                                                                                title: "Argon",
                                                                                url: "/urun-detay/677e26c3c44fb038b4a86410"
                                                                            },

                                                                            {
                                                                                title: "Oksijen",
                                                                                url: "/urun-detay/677e28e1c44fb038b4a865b4"
                                                                            },
                                                                            {
                                                                                title: "Karbondioksit",
                                                                                url: "/urun-detay/677e2b86c44fb038b4a86898"
                                                                            },
                                                                            {
                                                                                title: "Azot",
                                                                                url: "/urun-detay/677e2c5fc44fb038b4a8699c"
                                                                            },
                                                                            {
                                                                                title: "Helyum",
                                                                                url: "/urun-detay/677e2d6dc44fb038b4a86a06"
                                                                            },
                                                                            {
                                                                                title: "Asetilen",
                                                                                url: "/urun-detay/677e2e28c44fb038b4a86a5a"
                                                                            },
                                                                        ].map((el: any, index: number) => {
                                                                            return (
                                                                                <Link
                                                                                    key={"nested-" + index}
                                                                                    to={el.url}
                                                                                    style={{
                                                                                        padding: 0,
                                                                                        float: "left"
                                                                                    }}
                                                                                >
                                                                                    {el.title} {index < 20 ? ', ' : ''}
                                                                                </Link>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </Link>
                                                            </div>



                                                            <div>
                                                                <Link
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        padding: 0,
                                                                        paddingLeft: 10,
                                                                        fontSize: "13px",
                                                                        color: "#30355d"
                                                                    }}
                                                                    to={"#"}
                                                                    onMouseOver={(e) => e.preventDefault()}
                                                                >
                                                                    Sıvı
                                                                    <div
                                                                        style={{
                                                                            display: "inline-block",
                                                                            color: "red !important"
                                                                        }}
                                                                    >
                                                                        {[
                                                                            {
                                                                                title: "Sıvı Oksijen",
                                                                                url: "/urun-detay/677e2faec44fb038b4a86e5a"
                                                                            },

                                                                            {
                                                                                title: "Sıvı Azot",
                                                                                url: "/urun-detay/677e30efc44fb038b4a8705e"
                                                                            },

                                                                            {
                                                                                title: "Sıvı Karbondioksit",
                                                                                url: "/urun-detay/677e31c6c44fb038b4a87292"
                                                                            }
                                                                        ].map((el: any, index: number) => {
                                                                            return (
                                                                                <Link
                                                                                    key={"nested-" + index}
                                                                                    to={el.url}
                                                                                    style={{
                                                                                        padding: 0,
                                                                                        float: "left"
                                                                                    }}
                                                                                >
                                                                                    {el.title} {index < 2 ? ', ' : ''}
                                                                                </Link>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </Link>

                                                            </div>
                                                        </Link>

                                                        <Link to="/urun-detay/677e2077c44fb038b4a85c76"
                                                            style={{
                                                                padding: 0,
                                                                paddingLeft: 15,
                                                                paddingRight: 15,
                                                                fontSize: "14px"
                                                            }}
                                                        >
                                                            Medikal Gazlar
                                                            <div>
                                                                <Link
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        padding: 0,
                                                                        paddingLeft: 10,
                                                                        fontSize: "13px",
                                                                        color: "#30355d"
                                                                    }}
                                                                    to={"medikal-gazlar"}
                                                                    onMouseOver={(e) => e.preventDefault()}
                                                                >
                                                                </Link>
                                                            </div>
                                                        </Link>

                                                        <Link to="/urun-detay/677e2096c44fb038b4a85cfb"
                                                            style={{
                                                                padding: 0,
                                                                paddingLeft: 15,
                                                                paddingRight: 15,
                                                                fontSize: "14px"
                                                            }}
                                                        >
                                                            Özel Gazlar
                                                            <div>
                                                                <Link
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        padding: 0,
                                                                        paddingLeft: 10,
                                                                        fontSize: "13px",
                                                                        color: "#30355d"
                                                                    }}
                                                                    to={"ozel-gazlar"}
                                                                    onMouseOver={(e) => e.preventDefault()}
                                                                >
                                                                </Link>
                                                            </div>
                                                        </Link>

                                                        <Link to="/urun-detay/677e20aec44fb038b4a85d34"
                                                            style={{
                                                                padding: 0,
                                                                paddingLeft: 15,
                                                                paddingRight: 15,
                                                                fontSize: "14px"
                                                            }}
                                                        >
                                                            Yüksek Saflıkta Gazlar
                                                            <div>
                                                                <Link
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        padding: 0,
                                                                        paddingLeft: 10,
                                                                        fontSize: "13px",
                                                                        color: "#30355d"
                                                                    }}
                                                                    to={"yuksek-saflik-gazlar"}
                                                                    onMouseOver={(e) => e.preventDefault()}
                                                                >
                                                                </Link>
                                                            </div>
                                                        </Link>

                                                        <Link to="/urun-detay/677e20b8c44fb038b4a85d6d"
                                                            style={{
                                                                padding: 0,
                                                                paddingLeft: 15,
                                                                paddingRight: 15,
                                                                fontSize: "14px"
                                                            }}
                                                        >
                                                            Kurubuz
                                                            <div>
                                                                <Link
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        padding: 0,
                                                                        paddingLeft: 10,
                                                                        fontSize: "13px",
                                                                        color: "#30355d"
                                                                    }}
                                                                    to={"yuksek-saflik-gazlar"}
                                                                    onMouseOver={(e) => e.preventDefault()}
                                                                >
                                                                </Link>
                                                            </div>
                                                        </Link>

                                                    </li>

                                                    {/* Gaz Ekipmanları */}
                                                </ul>
                                            </li>

                                            {/* Gaz Ekipmanları*/}
                                            <li>
                                                <Link to="/urunler-liste/1">Gaz Ekipmanları</Link>
                                                <ul>
                                                    <li style={{
                                                        listStyle: "none",
                                                        fontWeight: "bold"
                                                    }}>
                                                        <Link className="nestedMenuItem1 nestedMenuItem2HeaderColor" to="/urunler/677e2f3dc44fb038b4a86cd1"
                                                        >
                                                            Valfler
                                                            <div>
                                                                <Link
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        padding: 0,
                                                                        paddingLeft: 10,
                                                                        fontSize: "13px",
                                                                        color: "#30355d"
                                                                    }}
                                                                    to={"valfler"}
                                                                    onMouseOver={(e) => e.preventDefault()}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            display: "inline-block",
                                                                            color: "red !important"
                                                                        }}
                                                                    >
                                                                        {[
                                                                            {
                                                                                title: "Argon",
                                                                                url: "/urun-detay/677e32b1c44fb038b4a873e6"
                                                                            },

                                                                            {
                                                                                title: "Azot",
                                                                                url: "/urun-detay/677e32bbc44fb038b4a87417"
                                                                            },

                                                                            {
                                                                                title: "Asetilen",
                                                                                url: "/urun-detay/677e32c5c44fb038b4a87448"
                                                                            },
                                                                            {
                                                                                title: "Narkoz",
                                                                                url: "/urun-detay/677e32d2c44fb038b4a87479"
                                                                            },
                                                                            {
                                                                                title: "Oksijen",
                                                                                url: "/urun-detay/677e32e0c44fb038b4a874aa"
                                                                            }
                                                                        ].map((el: any, index: number) => {
                                                                            return (
                                                                                <Link
                                                                                    key={"nested-" + index}
                                                                                    to={el.url}
                                                                                    style={{
                                                                                        padding: 0,
                                                                                        float: "left"
                                                                                    }}
                                                                                >
                                                                                    {el.title} {index < 4 ? ', ' : ''}
                                                                                </Link>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </Link>

                                                        <Link className="nestedMenuItem1 nestedMenuItem2HeaderColor" to="/urunler/677e2f53c44fb038b4a86d1b"

                                                        >
                                                            Regülatörler
                                                            <div>
                                                                <Link
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        padding: 0,
                                                                        paddingLeft: 10,
                                                                        fontSize: "13px",
                                                                        color: "#30355d"
                                                                    }}
                                                                    to={"regulatorler"}
                                                                    onMouseOver={(e) => e.preventDefault()}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            display: "inline-block",
                                                                            color: "red !important"
                                                                        }}
                                                                    >
                                                                        {[
                                                                            {
                                                                                title: "Oksijen",
                                                                                url: "/urun-detay/677e3ab22cbec1bd20097ed3"
                                                                            },

                                                                            {
                                                                                title: "Oksijen Verme Cihazı",
                                                                                url: "/urun-detay/677e3c252cbec1bd20098017"
                                                                            },

                                                                            {
                                                                                title: "Karbondioksit",
                                                                                url: "/urun-detay/677e3c4e2cbec1bd2009805e"
                                                                            },
                                                                            {
                                                                                title: "Asetilen",
                                                                                url: "/urun-detay/677e3c702cbec1bd2009809a"
                                                                            },
                                                                            {
                                                                                title: "Azot",
                                                                                url: "/urun-detay/677e3c9e2cbec1bd20098121"
                                                                            },
                                                                            {
                                                                                title: "Argon",
                                                                                url: "/urun-detay/677e3cf12cbec1bd20098173"
                                                                            }
                                                                        ].map((el: any, index: number) => {
                                                                            return (
                                                                                <Link
                                                                                    key={"nested-" + index}
                                                                                    to={el.url}
                                                                                    style={{
                                                                                        padding: 0,
                                                                                        float: "left"
                                                                                    }}
                                                                                >
                                                                                    {el.title} {index < 4 ? ', ' : ''}
                                                                                </Link>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </Link>

                                                        <Link className="nestedMenuItem1 nestedMenuItem2HeaderColor" to="/urun-detay/677e2f62c44fb038b4a86d54">
                                                            Çelik Çekme Tüpler
                                                        </Link>

                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <Link to="/urunler-liste/2">Yangın Söndürme</Link>
                                                <ul>
                                                    <li
                                                        style={{
                                                            listStyle: "none",
                                                            fontWeight: "bold"
                                                        }}
                                                    >
                                                        <Link className="nestedMenuItem1" to="/urun-detay/677e3f342cbec1bd2009857a"

                                                        >
                                                            ABC Tozlu Yangın Söndürücüler
                                                        </Link>

                                                        <Link className="nestedMenuItem1" to="/urun-detay/677e40402cbec1bd20098689"

                                                        >
                                                            Karbondioksitli Yangın Söndürücüler
                                                        </Link>

                                                        <Link className="nestedMenuItem1" to="/urun-detay/677e40652cbec1bd200986dd"

                                                        >
                                                            Köpüklü Yangın Söndürücüler
                                                        </Link>

                                                        <Link className="nestedMenuItem1" to="/urun-detay/677e40a02cbec1bd2009871b"
                                                        >
                                                            Halokarbonlu Yangın Söndürücüler
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <Link to="/urunler-liste/3">Dalış Tüpleri</Link>
                                            </li>
                                        </ul>
                                    </li>

                                    {/* Katalog */}
                                    <li>
                                        <Link to="/katalog">Bilgi Havuzu</Link>
                                        <ul>
                                            <li>
                                                <Link to="/katalog/tanitim">Tanıtım </Link>
                                            </li>
                                            <li>
                                                <Link to="/katalog/sds">SDS(Bilgi Güvenlik Formu) </Link>
                                            </li>
                                            <li>
                                                <Link to="/katalog/emniyet">Emniyet</Link>
                                            </li>
                                            <li>
                                                <Link to="/sertifikalar">Sertifikalar</Link>
                                            </li>
                                        </ul>
                                    </li>

                                    {/* Sertifikalar */}
                                    {/* <li>
                                        <Link to="/sertifikalar">Sertifikalar</Link>
                                    </li> */}

                                    {/* Galeri */}
                                    <li>
                                        <Link to="/galeri-liste/Resim">Galeri</Link>
                                    </li>

                                    {/* Haberler ve Duyurular */}
                                    <li>
                                        <Link to="/haberler-duyurular/haberler">Haberler</Link>
                                    </li>

                                    {/* İletişim */}
                                    <li>
                                        <Link to="/iletisim">İletişim</Link>
                                    </li>
                                </ul>
                            </nav>
                            {/* eof main nav */}
                            <span className="toggle_menu">
                                <span />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
